import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
};

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    item: [],
    furniture: [],
    about: [],
    cart: [],
  },
  getters: {
    // getProjectByUID: state => (uid, collection = state.furniture) => {
    //   let i = collection.length;
    //   while (i--) {
    //     if (collection[i].uid === uid) {
    //       return collection[i];
    //     }
    //   }
    // }
    totalAmount: (state) => {
      let amount = 0;
      state.cart.forEach((item) => (amount += item.price * item.quantity));
      return amount;
    },
    weightTotal: (state) => {
      let amount = 0;
      state.cart.forEach((item) => (amount += item.item.weight * item.quantity));
      return amount;
    },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
              disclaimer: "site.disclaimer.kirbytext",
              menu: {
                query: "site.children.listed",
                select: {
                  title: true,
                  uid: true
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('home')",
            select: {
              title: true,
              url: true,
              images: {
                query: "page.images",
                select: {
                  url: "file.url",
                  srcset: "file.srcset([400,800,1200,1600])",
                  thumb: "file.resize(400).url"
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_HOME", response.data.result);
        });
    },
    async loadFurniture({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('furniture')",
            select: {
              items: {
                query: "page.children.listed",
                select: {
                  title: true,
                  uid: true,
                  image: {
                    query: "page.images.sortBy('sort', 'asc').first",
                    select: {
                      url: "file.url",
                      srcset: "file.srcset([400, 800, 1200, 1600, 2000])",
                      thumb: "file.resize(200).url"
                    }
                  }
                },
                pagination: {
                  page: payload,
                  limit: 30
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_FURNITURE", response.data.result.items);
        });
    },
    async loadItem({ commit }, payload) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('furniture').children.find('${payload}')`,
            select: {
              title: true,
              uid: true,
              description: "page.description.kirbytext",
              price: true,
              stock: true,
              ondemand: true,
              material: true,
              furnituretype: true,
              width: true,
              height: true,
              depth: "page.formatdepth.value",
              images: {
                query: "page.images.sortBy('sort', 'asc')",
                select: {
                  url: "file.url",
                  srcset: "file.srcset([400, 800, 1200, 1600, 2000])",
                  thumb: "file.resize(200).url",
                  focusX: "file.focusPercentageX",
                  focusY: "file.focusPercentageY",
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_ITEM", response.data.result);
        });
    },
    async loadAbout({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('about')",
            select: {
              title: true,
              uid: true,
              text: "page.text.kirbytext",
              timeline: {
                  query: "page.timeline.toStructure",
                  select: {
                        year: "structureItem.year",
                        text: "structureItem.text"
                  }
              },
              contact: "page.contact.kirbytext",
              showroom: "page.showroom.kirbytext",
              colophon: "page.colophon.kirbytext",
              images: {
                query: "page.images.sortBy('sort')",
                select: {
                  url: "file.url",
                  srcset: "file.srcset([400, 800, 1200, 1600, 2000])",
                  thumb: "file.resize(200).url"
                }
              }
            }
          },
          { auth }
        )
        .then(function(response) {
          commit("SET_ABOUT", response.data.result);
        });
    }
  },
  mutations: {
    SET_SITE(state, data) {
      state.site = data;
    },
    SET_HOME(state, data) {
      state.home = data;
    },
    SET_FURNITURE(state, pages) {
      if (state.furniture.pagination) {
        state.furniture.pagination = pages.pagination;
        for (var i = 0; i < pages.data.length; i++) {
          state.furniture.data.push(pages.data[i]);
        }
      } else {
        state.furniture = pages;
      }
    },
    SET_ITEM(state, project) {
      state.item = project;
    },
    SET_ABOUT(state, data) {
      state.about = data;
    },
    addToCart({ cart }, product) {
      const itemIndex = cart.findIndex((item) => item.id === product.id);
      if (itemIndex < 0) {
        cart.push(product);
      } else {
        cart[itemIndex].quantity++;
      }
    },
    removeFromCart({ cart }, productid) {
      const itemIndex = cart.findIndex((item) => item.id === productid);
      cart.splice(itemIndex, 1);
    },
    decreaseItem({ cart }, productid) {
      const itemIndex = cart.findIndex((item) => item.id === productid);
      cart[itemIndex].quantity--;
    },
    increaseItem({ cart }, productid) {
      const itemIndex = cart.findIndex((item) => item.id === productid);
      if(cart[itemIndex].quantity < cart[itemIndex].stock) {
            cart[itemIndex].quantity++;
      }
    },
  }
});
